import PSWApiClient from './PSWApiClient'
import { SwlsDriversClient } from './SwlsDriversClient'

class DriversAdapter {
  constructor(
    stack,
    clientId,
    pswApiUrl = null,
    pswApiClient = new PSWApiClient(stack, clientId, pswApiUrl),
    swlsDriversClient = new SwlsDriversClient()
  ) {
    this.pswApiClient = pswApiClient
    this.swlsDriversClient = swlsDriversClient
  }

  async fetchBasicDrivers({ sku, os }) {
    return this.pswApiClient.fetchBasicDrivers({
      sku,
      os
    })
  }

  async getDriverDownloadUrl(sku, driverTypePreference) {
    return this.swlsDriversClient.getDriverDownloadUrl(
      sku,
      driverTypePreference
    )
  }

  async getDriverDownloadUrlByOS(os, easystartpro) {
    return this.swlsDriversClient.getDriverDownloadUrlByOS(os, easystartpro)
  }
}

export default DriversAdapter
